module.exports = __webpack_public_path__ + "h5/img/404.9e7400ed.png";